import { Star, Quote } from 'lucide-react';
import { Card } from '@/components/ui/card';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Kristian Keller',
      rating: 5,
      timeAgo: 'vor 2 Wochen',
      propertyType: 'Lebensmitteldiscounter',
      text: 'Nachdem schon längere Zeit ein Makler ohne Erfolg für mich tätig war, bekam ich von einem Freund die Telefonnummer von Herrn Heinrichs. Wir vereinbarten einen persönlichen Termin in seinen Büroräumen. Seine von anfang an kompetente Beratung gepaart mit beeindruckendem Fachwissen in diesem nicht alltäglichen Bereich (grösserer Lebensmitteldiscounter) gaben mir das Gefühl: "hier bist du gut aufgehoben". Das von Herrn Heinrichs mir nach kürzester Zeit vorgelegte hochwertige Exposé beinhaltete lückenlos alle Angaben zum Objekt mit beeindruckenden Drohnenfotos, dem für und wieder des Umfeldes und natürlich Vergleichsangebote. Wir legten noch einen realistischen Angebotspreis fest und von diesem Zeitpunkt an liess ich ihm freie Hand. Er kümmerte sich hervorragend um alles, hielt mich transparent über alles auf dem Laufenden. Der Verkauf ging zügig und reibungslos über die Bühne, nachdem alles von Herrn Heinrichs vorbereitet worden war. Die Arbeit dieses Maklers ist beeindruckend und ich kann ihn jederzeit weiterempfehlen.',
      highlight: 'PS: der erzielte Verkaufspreis konnte sich mehr als sehen lassen....',
      initial: 'K',
      verified: true
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-6 mx-auto"></div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: 'var(--navy-900)' }}>
            Das sagen unsere Mandanten
          </h2>
          <p className="text-lg max-w-3xl mx-auto" style={{ color: 'var(--gray-700)' }}>
            Echte Erfolgsgeschichten von Eigentümern, die uns ihr Vertrauen geschenkt haben.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 gap-8 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="glass-card p-8 md:p-10 hover:shadow-2xl transition-all duration-500"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <div className="flex justify-between items-start mb-6">
                <Quote 
                  className="h-12 w-12 opacity-20" 
                  style={{ color: 'var(--gold-600)' }} 
                />
                {testimonial.verified && (
                  <span className="text-xs font-semibold px-3 py-1 rounded-full bg-green-100 text-green-700">
                    Verifiziert
                  </span>
                )}
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 fill-current"
                    style={{ color: 'var(--gold-600)' }}
                  />
                ))}
                <span className="ml-2 text-sm font-medium" style={{ color: 'var(--gray-600)' }}>
                  {testimonial.timeAgo}
                </span>
              </div>

              {/* Testimonial Text */}
              <p 
                className="text-base md:text-lg leading-relaxed mb-4" 
                style={{ color: 'var(--gray-800)' }}
              >
                {testimonial.text}
              </p>

              {/* Highlight/PS */}
              {testimonial.highlight && (
                <p 
                  className="text-base italic font-medium mb-6 pl-4 border-l-4" 
                  style={{ 
                    color: 'var(--navy-700)',
                    borderColor: 'var(--gold-600)' 
                  }}
                >
                  {testimonial.highlight}
                </p>
              )}

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-6 border-t" style={{ borderColor: 'var(--gray-200)' }}>
                {/* Avatar */}
                <div 
                  className="w-14 h-14 rounded-full flex items-center justify-center text-white text-xl font-bold shadow-lg"
                  style={{
                    background: 'linear-gradient(135deg, #0F2744 0%, #2563A0 100%)'
                  }}
                >
                  {testimonial.initial}
                </div>
                
                {/* Name & Property */}
                <div>
                  <p className="font-bold text-lg" style={{ color: 'var(--navy-800)' }}>
                    {testimonial.name}
                  </p>
                  <p className="text-sm" style={{ color: 'var(--gray-600)' }}>
                    Verkauf: {testimonial.propertyType}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA Below Testimonials */}
        <div className="text-center mt-12">
          <p className="text-lg mb-6" style={{ color: 'var(--gray-700)' }}>
            Möchten Sie auch von unserer Expertise profitieren?
          </p>
          <a
            href="/kontakt"
            className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-[#D4A853] to-[#E5B960] rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            data-testid="testimonial-cta-button"
          >
            Kostenloses Erstgespräch vereinbaren
          </a>
        </div>
      </div>
    </section>
  );
};
